import { useState, useMemo, useRef } from "react";
import { Typewriter } from "./type-writer";

import "./BotStream.scss";
import { Message } from "@tencentcloud/chat";
type streamContentType = {
  type: "text" | "img" | "link";
  value: string;
};
interface IBotStreamProps {
  message: Message;
}
export function BotStream(props: IBotStreamProps) {
  const {
    message: {
      payload: { text },
    },
  } = props;
  const botStreamRef = useRef<HTMLDivElement>(null);

  const [streamContent, setStreamContent] = useState<Array<streamContentType>>([]);
  const [streamStatus, setStreamStatus] = useState(false);
  const typewriter = new Typewriter((item: streamContentType, isCompleted: boolean) => {
    setStreamContent((currentStreamContent: Array<streamContentType>) => {
      const currentStreamContentLength = currentStreamContent.length;
      if (
        currentStreamContentLength &&
        currentStreamContent[currentStreamContentLength - 1].type === item.type &&
        item.type !== "img"
      ) {
        const currentStreamContentLastItem = currentStreamContent[currentStreamContentLength - 1];
        const newLastStreamContent = {
          type: currentStreamContentLastItem.type,
          value: currentStreamContentLastItem.value.concat(item.value),
        };
        const newCurrentContent = [...currentStreamContent];
        newCurrentContent.pop();
        newCurrentContent.push(newLastStreamContent);
        return newCurrentContent;
      } else {
        return [...currentStreamContent, item];
      }
    });
    if (isCompleted) {
      typewriter.done();
      setStreamStatus(false);
    }
  });
  useMemo(() => {
    const messageListScrollDom = document.getElementsByClassName("message-list")[0];
    messageListScrollDom.scrollTop = messageListScrollDom.scrollHeight;
  }, [botStreamRef.current?.clientHeight]);
  useMemo(() => {
    startStream();
  }, [text]);
  function startStream() {
    setStreamContent([]);
    typewriter.add({
      type: "text",
      value: text,
    });
    typewriter.start();
    setStreamStatus(true);
  }

  const urlToLink = (text: string) => {
    const urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
    return text.replace(urlRegex, function(website){
        return "<a class='website' href='" + website +"' target='_blank'>" + website + "</a>";
    });
  }

  return (
    <div className="message-text-content" ref={botStreamRef}>
      {streamContent.map((item: any, index: any) => {
        if (item.type === "text") {
          if (streamStatus) {
            return (
              <span className="typewriter" key={index}>
                {item.value}
              </span>
            )
          }
          return (
            <span className="text" key={index} dangerouslySetInnerHTML={{__html: urlToLink(item.value)}}></span>
          );
        } else if (item.type === "img") {
          return (
            <img className={streamStatus ? "typewriter " : "text"} key={index} src={item.value} alt="" />
          );
        }
      })}
    </div>
  );
}
